import PropTypes from 'prop-types'

export const model = [
  {
    key: 'thirdPartyNumber',
    label: 'Fleet Number',
    column: {
      visible: true,
      width: 110,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'customerName',
    label: 'Fleet Name',
    column: {
      visible: true,
      width: 220,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'vehicleRegistration',
    label: 'Vehicle Registration',
    column: {
      visible: true,
      width: 150,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'driver',
    label: 'Driver Name',
    column: {
      visible: true,
      width: 200,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'driverEmail',
    label: 'Driver Email',
    column: {
      visible: true,
      width: 220,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'driverMobile',
    label: 'Driver Phone',
    column: {
      visible: true,
      width: 160,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'lastReadingDate',
    label: 'Last Recorded Odometer',
    column: {
      visible: true,
      width: 180,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'datasource',
    label: 'Source of Last Odometer',
    column: {
      visible: true,
      width: 180,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'odometer',
    label: 'Reading of Last Odometer',
    column: {
      visible: true,
      width: 180,
    },
    prop: {
      type: PropTypes.number,
      value: null,
    },
  },
  {
    key: 'timeSinceLastReading',
    label: 'Time since Odometer',
    column: {
      visible: true,
      width: 160,
    },
    prop: {
      type: PropTypes.number,
      value: null,
    },
  },
  {
    key: 'costCentre',
    label: 'Cost Centre',
    column: {
      visible: true,
      width: 130,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
  {
    key: 'fleetController',
    label: 'Fleet Controller',
    column: {
      visible: true,
      width: 160,
    },
    prop: {
      type: PropTypes.string,
      value: '',
    },
  },
]

const config = {
  title: 'Missing Odometers',
  state: {
    columnsSort: {
      column: 'timeSinceLastReading',
      direction: 'asc',
    },
  },
  api: {
    filter: '/filteroptions/missingodometer',
    resource: '/report/missingodometer',
    download: '/download/missingodometer',
  },
  idKey: 'thirdPartyNumber',
  model,
  headers: [
    'thirdPartyNumber',
    'customerName',
    'vehicleRegistration',
    'driver',
    'driverEmail',
    'driverMobile',
    'lastReadingDate',
    'datasource',
    'odometer',
    'timeSinceLastReading',
    'costCentre',
    'fleetController',
  ],
  filters: [
    {
      key: 'costCentre',
      label: 'Cost Centre',
      prop: {
        type: PropTypes.string,
        value: '',
      },
    },
    {
      key: 'fleetController',
      label: 'Fleet Controller',
      prop: {
        type: PropTypes.string,
        value: '',
      },
    },
    {
      key: 'fleetId',
      label: 'Fleet ID',
      prop: {
        type: PropTypes.string,
        value: '',
      },
    },
  ],
}

export default config
